import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import "./style.scss";

const PasswordReset = () => {
    const [newPassword, setNewPassword] = useState('');
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState (false);

    useEffect (() => {
        console.log ("token", token);
    }, []);


    const handleSubmit = async () => {
        try {
            const response = await fetch(`https://www.calmestcrypto.com/password-reset-verify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ newPassword, token })
            });
            const data = await response.json();
            console.log (data);
            setMessage(data.message);
            setSuccess (data.message === "Password reset successful!");
            
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <div className="password-reset-container">
            <h1>Enter New Password</h1>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New Password" />
            <button onClick={handleSubmit}>Reset Password</button>
            <div className="feedback">{message}</div>
            {success && <Link to="/login" className="loginLink">Log In</Link>}
        </div>
    );
}

export default PasswordReset;